import { memo, useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { ModalForm } from '@entities/modal'

const createComponent = (WrappedComp, onLogout) => () => {
  const modals = useSelector((state) => state.modals, shallowEqual)

  useEffect(() => {
    let hideOverflow = false

    modals.forEach(({ eventModal, noWrapper }) => {
      if (eventModal && !noWrapper) {
        hideOverflow = true
      }
    })

    if (hideOverflow) {
      document.querySelector('body').classList.add('hide-overflow')
    } else {
      document.querySelector('body').classList.remove('hide-overflow')
    }
  }, [modals])

  return (
    <>
      {modals.map(
        (
          {
            id,
            type,
            title,
            content,
            buttons,
            functions,
            //
            fixPosition,
            //
            eventModal,
            //
            enableBgExit,
            enableModalExit,
            //
            noWrapper,
          },
          modalI
        ) => (
          <ModalForm
            key={id}
            disabled={modalI !== modals.length - 1}
            //
            id={id}
            type={type}
            title={title}
            buttons={buttons || []}
            functions={functions}
            //
            fixPosition={fixPosition || false}
            //
            eventModal={eventModal || null}
            //
            enableBgExit={enableBgExit === undefined ? true : enableBgExit}
            enableModalExit={
              enableModalExit === undefined ? false : enableModalExit
            }
            noWrapper={noWrapper === undefined ? false : noWrapper}
          >
            {content}
          </ModalForm>
        )
      )}
      <WrappedComp onLogout={onLogout} />
    </>
  )
}
//
//
//

const Wrapper = (WrappedComp, onLogout) => {
  const Component = createComponent(WrappedComp, onLogout)

  return <Component />
}

export const withModals = (component) =>
  memo((props) => {
    const { onLogout } = props

    return Wrapper(component, onLogout)
  })
